/**
 * 错误对象，可能还包含不止以下信息
 * @typedef {object} Error
 * @property {number} errorCode 错误状态码
 * @property {*} errorData 错误数据
 * @property {string} errorMessage 错误信息
 */
/**
 * 使用指定的消息创建错误
 * @param {object} [error={}] other错误相关数据
 * @param {number} [errorCode=9999] 错误状态码
 * @param {*} [errorData=''] 错误相关数据
 * @param {string} [errorMessage='http link failed'] 错误信息
 * @returns {Error} 创建的错误
 */
export default function createError(error, errorCode, errorData, errorMessage) {
    if (errorCode === void 0) {
        errorCode = 9999;
    }
    if (errorData === void 0) {
        errorData = '';
    }
    if (errorMessage === void 0) {
        errorMessage = 'http link failed';
    }
    return Object.assign({}, error, {
        errorCode: errorCode,
        errorData: errorData,
        errorMessage: errorMessage,
    });
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/request/createError.js
// module id = null
// module chunks = 